export const Construction = () => {
  return (
    <>
      <h1>under construction</h1>
      <p>Página em construção! Estamos preparando algo incrível para você. Volte em breve!</p>

      <p>Estamos trabalhando para oferecer a melhor experiência possível. Agradecemos pela paciência e mal podemos esperar para mostrar o que está por vir. Fique atento para novidades!</p>
    </>
  );
};